import { Link, type LinkProps, NavLink, type NavLinkProps } from 'react-router-dom';
import { useHubHref } from '@/lib/global/hub-path';

export function HubNavLink({ to, ...rest }: NavLinkProps) {
  const href = useHubHref();
  return <NavLink to={typeof to === 'string' ? href(to) : to} {...rest} />;
}

export function HubLink({ to, ...rest }: LinkProps) {
  const href = useHubHref();
  return <Link to={typeof to === 'string' ? href(to) : to} {...rest} />;
}
